import { render, staticRenderFns } from "./baby-gold.vue?vue&type=template&id=02956802&scoped=true&"
import script from "./baby-gold.vue?vue&type=script&lang=js&"
export * from "./baby-gold.vue?vue&type=script&lang=js&"
import style0 from "./baby-gold.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./baby-gold.vue?vue&type=style&index=1&id=02956802&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02956802",
  null
  
)

export default component.exports